import "css/style.css"
import {lazyLoading} from "./lazyload/lazyload-init"
import "@components/main-nav"
import "@components/main-header/main-header"
import "@components/main-header/main-header-search/main-header-search"
window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadMain() {
  await import("./main")
}
loadMain()

async function loadFancybox() {
  await import("./fancybox/fancybox-gallery-id-generator")
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("./fancybox/fancybox")
    document.dispatchEvent(new Event("fancyboxInit"))
  }
}
loadFancybox()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./swiper/swiper")
    document.dispatchEvent(new Event("swiperInit"))
  }
}
loadSwiper()

async function loadOverlayScrollbars() {
  if (document.querySelectorAll(".u-scrollbar").length) {
    await import("./overlayscrollbars")
    document.dispatchEvent(new Event("overlayscrollbarsInit"))
  }
}
loadOverlayScrollbars()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("./slim-select/slim-select")
    document.dispatchEvent(new Event("slimselectInit"))
  }
}
loadSlimSelect()

async function loadFlatpickr() {
  if (document.querySelectorAll(".flatpicker").length) {
    await import("js/flatpickr")
    document.dispatchEvent(new Event("flatpickrInit"))
  }
}
loadFlatpickr()

async function loadModals() {
  if (document.querySelectorAll(".c-modal").length) {
    await import("@components/modal/modal")
  }
}
loadModals()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file").length) {
    await import("@components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadPasswordField() {
  if (document.querySelectorAll(".f-text.--password").length) {
    await import("@components/fields/text-field/text-field--password")
  }
}
loadPasswordField()

async function loadTextField() {
  if (document.querySelectorAll(".f-text, .f-textarea").length) {
    await import("@components/fields/text-field/text-field")
  }
}
loadTextField()

async function loadCalendar() {
  if (document.querySelectorAll(".s-calendar").length) {
    await import("@components/sections/calendar-section/calendar-section")
  }
}
loadCalendar()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("@components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadNotification() {
  if (document.querySelectorAll(".i-notification").length) {
    await import("@components/items/notification-item/notification-item")
  }
}
loadNotification()

async function loadFaqItem() {
  if (document.querySelectorAll(".i-faq").length) {
    await import("@components/items/faq-item/faq-item")
  }
}
loadFaqItem()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("@components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadBaseForm() {
  if (document.querySelectorAll("form.--validate").length) {
    await import("@components/base-form/base-form")
  }
}
loadBaseForm()

async function loadScrollUp() {
  if (document.querySelectorAll(".c-scroll-up").length) {
    await import("@components/scroll-up/scroll-up")
  }
}
loadScrollUp()

async function loadExternalSvgLoader() {
  if (document.querySelectorAll(".c-svg").length) {
    await import("@components/svg")
  }
}
loadExternalSvgLoader()

async function loadHeaderLineClamp() {
  if (document.querySelectorAll(".--js-header-line-clamp").length) {
    await import("js/header-line-clamp/header-line-clamp")
  }
}
loadHeaderLineClamp()

async function loadSelectLinkItem() {
  if (document.querySelectorAll(".i-select-link").length) {
    await import("@components/items/select-link-item/select-link-item")
  }
}
loadSelectLinkItem()

async function loadAdvertGroupSlider() {
  if (document.querySelectorAll(".g-advert.--slider").length) {
    await import("@components/groups/advert-group/advert-group--slider")
  }
}
loadAdvertGroupSlider()

async function loadSurveyForm() {
  if (document.querySelectorAll(".f-survey").length) {
    await import("@components/forms/survey-form/survey-form")
  }
}
loadSurveyForm()

async function loadUserItem() {
  if (document.querySelectorAll(".i-user").length) {
    await import("@components/items/user-item/user-item")
  }
}
loadUserItem()

async function loadHeaderDropdownItem() {
  if (document.querySelectorAll(".i-header-dropdown").length) {
    await import("@components/items/header-dropdown-item/header-dropdown-item")
  }
}
loadHeaderDropdownItem()

async function loadCommentSection() {
  if (document.querySelectorAll(".s-comment").length) {
    await import("@components/sections/comment-section/comment-section")
  }
}
loadCommentSection()

async function loadCategoryItems() {
  if (document.querySelectorAll(".i-category").length) {
    await import("@components/items/category-item/category-item")
  }
}
loadCategoryItems()

async function loadAsyncFiltering() {
  if (document.querySelectorAll("[data-async-filtering]").length) {
    await import("js/async-filtering/async-filtering")
  }
}
loadAsyncFiltering()

async function loadAsyncLoad() {
  if (document.querySelectorAll("[data-async-load]").length) {
    await import("js/async-load/async-load")
  }
}
loadAsyncLoad()

async function loadAsyncSearch() {
  if (document.querySelectorAll(".--js-search").length) {
    await import("js/async-search/async-search")
  }
}
loadAsyncSearch()

async function loadAdLayoutContainer() {
  if (document.querySelectorAll(".layout-ad-container").length) {
    await import("@components/layout-ad-container/layout-ad-container")
  }
}
loadAdLayoutContainer()
